export default __webpack_public_path__ + "static/media/ninth.8dc25dab.png";